import styled from "@emotion/styled";
import { Stack } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const StyledConnectionCard = styled(Stack)`
  width: 100%;
  height: 154px;
  border-radius: 12px;
  background-color: ${({ theme }) => alpha(theme.palette.grey.gm, 0.12)};
  align-items: center;
  justify-content: center;
  /* filter: grayscale(1);
  opacity: 0.5;
  transition: filter 1s ease;
  &:hover {
    filter: none;
    opacity: 1;
  } */
`;
